// extracted by mini-css-extract-plugin
module.exports = {"container":"case-study-module--container--3zvNJ","comingSoon":"case-study-module--comingSoon--1tLSb","comingSoonContent":"case-study-module--comingSoonContent--3jdQY"};